import { Navigate, Route as RRoute, Routes as RRoutes } from 'react-router-dom'
import PropTypes from 'prop-types'
import React from 'react'

import { keyIndex } from 'helpers'
import { LOGIN, MY_5_DYNAMICS } from 'urls'
import { formatRoute } from 'constants/urls'
import routes from 'constants/routes'
import Route from 'components/Route'

const Routes = props => {
  const { accountId } = props

  return (
    <RRoutes>
      {/* Root redirect — send authenticated users to my-5-dynamics, others to login */}
      <RRoute
        index
        element={
          accountId !== null ? (
            <Navigate to={formatRoute(MY_5_DYNAMICS, { accountId })} replace />
          ) : (
            <Navigate to={LOGIN} replace />
          )
        }
      />
      {keyIndex(routes).map(({ id, path, component, layout, ...rest }) => (
        <RRoute key={id} path={path} element={<Route component={component} layout={layout} {...rest} />} />
      ))}
    </RRoutes>
  )
}

Routes.propTypes = {
  accountId: PropTypes.number,
}

Routes.defaultProps = {
  accountId: null,
}

export default Routes
